module.exports = __webpack_public_path__ + "static/media/logo.74156aa2.webp";